import type { BundleOfferDto } from './bundleOffers.schema';
import { ENDPOINTS } from '../endpoints';
import { httpClient } from '../httpClient';
import { BundleOffersResponseSchema } from './bundleOffers.schema';

export const bundlesApi = {
  async getUserBundleOffers() {
    const response = await httpClient.get<BundleOfferDto[]>(ENDPOINTS.bundles.offers);

    return BundleOffersResponseSchema.parse(response ?? []);
  },

};
